import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import './cancellationFormValidation'

var AjaxFormModule = require('../../modules/ajaxForm');
var LocalizationModule = require('../../modules/localization')

if (document.addEventListener) {
    window.addEventListener('pageshow', function (event) {
            if (event.persisted || performance.getEntriesByType("navigation")[0].type === 'back_forward') {
                location.reload();
            }
        },
        false);
}

$(document).ready(function () {
    const subscriptionId = $('[data-subscription-id]').data('subscription-id');

    let formsSelectors = {
        cancelSubscription: '.subscription-cancel',
        cancelQuestion: '.subscription-cancel-question',
        loginByCodeRequest: '.custom-login-by-code-request',
        loginByCode: '.custom-login-by-code',
        loginByPassword: '.custom-login-by-password',
        loginByCodeRequestResend: '.custom-login-by-code-resend',
        chooseSubs: '.choose-subs'
    };
    let errorsContainer = '.cl-validation-errors';

    let formValidator;

    if ($('#lh-custom-login').length > 0) {
        $('#lh-custom-login').magnificPopup({
            type: 'ajax',
            ajax: {
                settings: {type: 'POST'}
            },
            showCloseBtn: false,
            closeOnBgClick: false,
            removalDelay: 300,
            fixedContentPos: true,
            mainClass: 'mfp-fade cl-wraper',
            callbacks: {
                ajaxContentAdded: function () {
                    tippy('[data-tippy-content]', {
                        placement: 'top',
                        theme: 'light',
                        arrow: true,
                        animation: 'fade',
                        appendTo: document.body,
                    });
                }
            }
        }).magnificPopup('open');
    }

    if ($('#lh-subsc-choose').length > 0) {
        $('#lh-subsc-choose').magnificPopup({
            type: 'ajax',
            showCloseBtn: false,
            closeOnBgClick: false,
            fixedContentPos: true,
            removalDelay: 300,
            mainClass: 'mfp-fade cl-wraper'
        }).magnificPopup('open');
    }

    // change login mode
    $(document).on('click', '.cl-toggle-login-mode', function () {
        $('.by_password').toggleClass('active');
        $('.code_request').toggleClass('active');
        if (formValidator) {
            formValidator.resetForm();
        }
        $('.lh-validation-item').removeClass('has-error');
        $('.cl-validation-errors').html('');
    });

    // edit subscription address
    $('.subscription-edit-js').on('click', function (e) {
        let date = new Date();
        date.setTime(date.getTime() + (2 * 60 * 1000));
        document.cookie = 'profile-subscription-edit=' + $(this).data('subscription-id') + ';expires=' + date.toUTCString() + ';path=/';
    });

    //  menu
    $('.unsub-header__menu-m').on('click', function () {
        $('.unsub-header').toggleClass('unsub-header--open');
        $('.unsub-header__mobile').fadeToggle(200);
        $('.unsub-header__mobile-menu').toggleClass('unsub-header__mobile-menu--open');
        $('body').toggleClass('no-scroll');
    });

    //  cancel select
    const limit = 3;
    let count = 0;
    $('.unsub-cancel__item').on('click', function () {
        if (!$(this).hasClass('unsub-cancel__item--selected') && (count < limit)) {
            $(this).toggleClass('unsub-cancel__item--selected');
            $('input', $(this)).prop('disabled', false);
            count++;
        } else if ($(this).hasClass('unsub-cancel__item--selected') && (count <= limit)) {
            $(this).toggleClass('unsub-cancel__item--selected');
            $('input', $(this)).prop('disabled', true);
            count--;
        }
    });

    $('.unsub-cancel__item-text input').on('click', function (e) {
        e.stopPropagation();
    });

    //  navigation
    $('.unsub-nav-btn').on('click', function () {
        let target = $(this).attr('data-target');

        $('.unsub-header').removeClass('unsub-header--open');
        $('.unsub-header__mobile').fadeOut(200);
        $('.unsub-header__mobile-menu').removeClass('unsub-header__mobile-menu--open');
        $('body').removeClass('no-scroll');

        $('html, boby').animate({
            scrollTop: $(`.${target}`).offset().top - 80
        }, 1000);
    });

    // change email on the login flow
    $(document).on('click', '.cl-change-email', function () {
        $('.cl-login-modal').removeClass('active');
        $('.code_request').addClass('active');
        $('.cl-code-input').val('');
        if (formValidator) {
            formValidator.resetForm();
        }
        $('.lh-validation-item').removeClass('has-error');
        $('.cl-validation-errors').html('');
    });

    // forms submit
    $(document).on('submit', Object.values(formsSelectors).join(','), function (e) {
        e.preventDefault();
        let form = $(this);

        $('button', form).attr('disabled', true).addClass('disabled');
        $('.cl-message').text('').hide();

        let validationRules;
        let errorContainerSelector;
        let localization;
        if (form.is(formsSelectors.loginByCodeRequest)) {
            validationRules = AjaxFormModule.validationRules.cancel_flow.custom_login_by_code_requets;
            errorContainerSelector = formsSelectors.loginByCodeRequest;
            localization = LocalizationModule.getTranslationsByKey('custom_login');
        } else if (form.is(formsSelectors.loginByCode)) {
            validationRules = AjaxFormModule.validationRules.cancel_flow.custom_login_by_code;
            errorContainerSelector = formsSelectors.loginByCode;
            localization = LocalizationModule.getTranslationsByKey('custom_login');
        } else if (form.is(formsSelectors.loginByPassword)) {
            validationRules = AjaxFormModule.validationRules.cancel_flow.custom_login_by_password;
            errorContainerSelector = formsSelectors.loginByPassword;
            localization = LocalizationModule.getTranslationsByKey('custom_login');
        } else if (form.is(formsSelectors.chooseSubs)) {
            validationRules = AjaxFormModule.validationRules.cancel_flow.choose_subs;
            errorContainerSelector = formsSelectors.chooseSubs;
            localization = LocalizationModule.getTranslationsByKey('custom_login');
        } else if (form.is(formsSelectors.cancelQuestion)) {
            validationRules = AjaxFormModule.validationRules.cancel_flow.question;
            errorContainerSelector = formsSelectors.cancelQuestion;
            localization = LocalizationModule.getTranslationsByKey('unsub');
        }
        errorContainerSelector = errorContainerSelector + ' ' + errorsContainer;

        formValidator = AjaxFormModule.validate(form, validationRules, localization, errorContainerSelector);

        if (form.valid()) {
            AjaxFormModule.submit(form, function (response) {
                $('button', form).attr('disabled', false).removeClass('disabled');

                if (response.email) {
                    $('input[name="email"].cl-input').val(response.email);
                }

                if (response.message) {
                    $('.cl-message').text(response.message).show();
                } else {
                    $('.cl-message').text('').hide();
                }

                // disable resend form
                $(formsSelectors.loginByCodeRequestResend).show();
                $('.cl-resend-disable').hide();
                if (response.active_codes_limit != undefined && response.active_codes_limit == false) {
                    $(formsSelectors.loginByCodeRequestResend).hide();
                    $('.cl-resend-disable').show();
                }

                if (form.is(formsSelectors.cancelQuestion)) {
                    form.html(`<div class="success-message">${localization.question_form_submit_success}</div>`)
                        .children().hide().fadeIn();
                    return;
                }

                // ajax result
                if (response.url) {
                    window.location = response.url;
                } else if (response.modal_type_opened) {
                    $('.cl-login-modal').removeClass('active');
                    $('.' + response.modal_type_opened).addClass('active');
                } else {
                    location.reload();
                }
            }, function (response) {
                $(formsSelectors.loginByCodeRequestResend).show();
                $('.cl-resend-disable').hide();
                if (response.active_codes_limit != undefined && response.active_codes_limit == false) {
                    $(formsSelectors.loginByCodeRequestResend).hide();
                    $('.cl-resend-disable').show();
                }
                $('button', form).attr('disabled', false).removeClass('disabled');
            }, $(errorContainerSelector), true);
        } else {
            $('button', form).attr('disabled', false).removeClass('disabled');
        }
    });

    const trackingData = $('.unsub-track--steps');
    const checkTrackDataBlock = () => {
        if (trackingData.is(':visible') && trackingData.prop('scrollHeight') < 260) {
            trackingData.removeClass('collapsed');
        }
    }

    trackingData.one('click', () => trackingData.removeClass('collapsed'));

    $('.unsub-change-period-form .unsub-change-option').on('click', function () {
        if ($(this).hasClass('active')) {
            return;
        }
        $('.unsub-change-period-form .unsub-change-option.active').removeClass('active').find('.unsub-change-option--description').slideUp()
        $(this).addClass('active').find('.unsub-change-option--description').slideDown();

        // Set input
        const value = $(this).data('option')
        $('input[name="change_type"]').val(value);

        $('.unsub-plain-button').attr('disabled', false).removeClass('unsub-disabled');
    });

    $('.unsub-choose-payment-amount .unsub-change-option').on('click', function () {
        if ($(this).hasClass('active')) {
            return;
        }
        $('.unsub-choose-payment-amount .unsub-change-option.active').removeClass('active')
        $(this).addClass('active')

        // Set input
        const value = $(this).data('option')
        $('input[name="change_type"]').val(value);

        $('.unsub-plain-button').attr('disabled', false).removeClass('unsub-disabled');
    });

    checkTrackDataBlock();

    $('[data-back-button]').on('click', function () {
        history.back();
    });

    if ($('[data-js-next-box-url]').length) {
        $.get($('[data-js-next-box-url]').val(), response => {
            if (response?.image) {
                $('[data-js-next-box-img]').attr('src', response.image);
            }
            if (response?.description) {
                $('[data-js-next-box-text]').html(response.description);
            }

            // Disable default text for wide block
            if ((response?.message === 'Next box not found' && $('.unsub-steps-s-block--wider').length)) {
                $('[data-js-next-box-text]').html('');
            }

            $('.unsub-steps-show-loader').removeClass('unsub-steps-show-loader')
        });
    }

    // Setup retention cache
    $(window).on('load', function () {
        if ($('[data-setup-cache-url]').length) {
            $.get($('[data-setup-cache-url]').data('setup-cache-url'))
        }
    });

    // Control retention forms submit
    $('.retention-post-form').on('submit', function (event) {
        if ($(this).hasClass('loading')) {
            event.preventDefault();
        }
        $(this).addClass('loading');
    });
});
